<template>
  <section class="dialogBind">
    <el-dialog
      :close-on-click-modal="false"
      center
      :title="$t('global.绑定手机号')"
      :visible="true"
      width="500px"
      top="30vh"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <el-form>
        <div>
          <li>
            <el-select
              v-model="form.areaCode"
              filterable
              remote
              :remote-method="getAreaCodeList"
              :placeholder="$t('global.请选择区号')"
              class="areaCode"
            >
              <el-option
                :label="item.areaCode"
                :value="item.areaCode"
                v-for="item in areaCodeList"
                :key="item.id"
              >
                <p>
                  {{item.title}}
                  <span style="padding-left:10px;float: right;">{{item.areaCode}}</span>
                </p>
              </el-option>
            </el-select>

            <el-form-item class="phone">
              <el-input type="text" v-model="form.phone" :placeholder="$t('global.输入手机号')"></el-input>
            </el-form-item>
          </li>
          <li>
            <span>{{$t('global.验证码')}}</span>
            <el-form-item class="phoneCode">
              <el-input type="text" v-model="form.code" :placeholder="$t('global.验证码')"></el-input>
              <a
                href="javascript:;"
                class="sendCode"
                @click.prevent="checkAccount"
              >{{!time?$t('global.获取验证码'):`${time}s${$t('global.后重新获取')}`}}</a>
            </el-form-item>
          </li>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="binding">{{$t('global.绑定')}}</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        areaCode: "86",
        phone: "",
        code: ""
      },
      time: 0,
      areaCodeList: []
    };
  },
  props: {
    argument: {
      type: Object
    },
    close: {
      type: Function
    }
  },
  watch: {
    time(val) {
      if (val >= 1) {
        setTimeout(() => {
          this.time--;
        }, 1000);
      }
    }
  },
  created() {
    this.getAreaCodeList("");
  },
  created() {},
  methods: {
    getAreaCodeList(val) {
      let config = {
        loading: false,
        params: {
          keyWords: val || undefined,
          pageSize: 500,
          pageIndex: 1,
          orderBy: "createTime"
        }
      };
      let $this = this;
      this.$http.get("/api/areacode/areaCodeList", config).then(response => {
        this.areaCodeList = response.data.list;
      });
    },
    binding() {
      //校验手机号 $t('global.验证码') 返回信息 该手机号存不存在;
      const url = `/api/passport/checkCodepc`;
      const isNew = this.argument.isNew;
      const params = {
        ...this.argument.params,
        phone: this.form.phone,
        areaCode: "+" + this.form.areaCode,
        code: this.form.code,
        type: this.argument.isNew ? 8 : 6
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          if (/** $t('global.已绑定成功'),登录了  */ res.data.loginSuccess) {
            localStorage.setItem("auth_token", res.data.token);
            this.$http.get("/api/u/info/get").then(response => {
              this.$store.dispatch("setNewState", {
                peopleMessage: response.data,
                accountUser: response.data,
                isLogin: true
              });
              localStorage.setItem("isLogin", "true");
            });
            this.handleClose();
          } else if (
            /**未成功登录 && 手机号已存在存在 */ !res.data.loginSuccess &&
            res.data.phoneRepetition
          ) {
            if (
              /** 老用户 && $t('global.手机号未被绑定第三方') */ !isNew &&
              !res.data.bindingRepetition
            ) {
              this.$message.warning(
                this.$t("global.这个手机号已经绑定其他账户")
              );
            } else if (
              /** $t('global.手机号已被绑定第三方')*/ res.data.bindingRepetition
            ) {
              this.$message.warning(
                this.$t("global.这个手机号已经绑定其他三方账号")
              );
            }
            this.handleClose();
          } else if (/**$t('global.昵称重复') */ res.data.nickRepetition) {
            localStorage.setItem("auth_token", res.data.token);
            this.$message(
              `${this.$t("global.昵称重复")},${this.$t("global.请修改昵称")}`
            );
            setTimeout(() => {
              this.$router.push(
                `/setInfo/nickname?userId=${res.data.userId}&login=true`
              );
            }, 1000);
          }
        }
      });
    },
    handleClose() {
      this.$emit("close");
    },
    checkAccount() {
      if (!this.time) {
        if (this.form.email || this.form.phone) {
          let params = {
            phone: this.form.phone,
            type: 1,
            areaCode: "+" + this.form.areaCode
          };
          const url = `/api/customer/sendPhoneOrEmailCode`;
          this.$http.post(url, params).then(res => {
            if (res.code === "OK") {
              this.$message.success(this.$t("global.验证码已发送"));
              this.time = 60;
            }
          });
        } else {
          this.$message(this.$t("global.请输入绑定的账号"));
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
li {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;

  .phone {
    margin-bottom: 0;
  }

  .areaCode {
    width: 100px;
  }

  &>span {
    width: 100px;
    line-height: 40px;
  }

  .sendCode {
    position: absolute;
    right: 20px;
    top: 0;
    color: #5f86fc;
  }
}

.el-dialog__body {
  .container {
    width: 100%;

    ul {
      padding: 0 40px 40px;

      li {
        border-bottom: 1px solid #eaebec;
        display: flex;
        flex-direction: row;
        padding: 20px 0 5px;

        .areaCode {
          width: 80px;
        }

        span {
          color: #333;
          line-height: 40px;
          width: 80px;
        }

        input {
          flex: 1;
        }

        .el-form-item {
          flex: 1;
          margin-bottom: 0;

          .el-form-item__content {
            position: relative;

            input {
              border: 0;
            }
          }
        }
      }
    }
  }

  .container.cancel {
    p, h5 {
      color: #333;
      line-height: 20px;
      padding-bottom: 20px;
      font-size: 14px;
    }
  }
}
</style>
<style lang="stylus">
.dialogBind {
  .el-dialog__header {
    border-bottom: 1px solid #eaebec;
  }

  .el-form-item {
    flex: 1;

    .el-form-item__content {
      input {
        border: 0;
        padding: 0;
      }
    }
  }

  .areaCode {
    .el-input--suffix {
      input {
        border: none;
      }
    }

    .el-input--suffix {
      .el-input__suffix-inner {
        .el-select__caret {
          color: #c0c4cc;
          font-size: 14px;
          transition: transform 0.3s;
          transform: rotate(180deg);
          cursor: pointer;

          &:before {
            content: '\e6e1';
          }

          &:after {
            content: '';
            height: 100%;
            width: 0;
            display: inline-block;
            vertical-align: middle;
          }

          &.is-reverse {
            transform: rotate(0deg);
          }
        }
      }
    }
  }

  .el-dialog__footer {
    padding-bottom: 40px;

    .el-button {
      width: 60%;
      height: 40px;
      margin-bottom: 10px;
      margin-left: 0;

      &:not(.is-plain) {
        background: #3664ED;
      }
    }

    .marge {
      display: block;
      color: #3664ED;
      padding: 10px;
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/pages/dialog/ThirdLoginBindPhone.vue